import { render, staticRenderFns } from "./GameHelp.vue?vue&type=template&id=01fe0503"
import script from "./GameHelp.vue?vue&type=script&lang=js"
export * from "./GameHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01fe0503')) {
      api.createRecord('01fe0503', component.options)
    } else {
      api.reload('01fe0503', component.options)
    }
    module.hot.accept("./GameHelp.vue?vue&type=template&id=01fe0503", function () {
      api.rerender('01fe0503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameHelp.vue"
export default component.exports